/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const GithubLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M5.88 18.65a4 4 0 0 1-.86-.81l-.46-.58c-.46-.58-.76-.84-1.06-.95a1 1 0 1 1 .68-1.88c.75.27 1.26.73 1.94 1.58l.44.54q.28.34.44.44.3.22 1.15.14.04-.57.2-1.1C5.38 15.32 3.7 13.4 3.7 9.65q.01-1.87 1.06-3.3a5.2 5.2 0 0 1 .3-3.18 1 1 0 0 1 .63-.59l.2-.04c.81-.13 1.95.17 3.42 1.1a12 12 0 0 1 5.38 0c1.47-.94 2.6-1.23 3.42-1.1l.21.05q.45.15.62.58a5.2 5.2 0 0 1 .3 3.19q1.05 1.4 1.06 3.29c0 3.76-1.67 5.66-4.64 6.4q.19.61.19 1.37v2.01l-.01.7a1 1 0 0 1-.02 1.97c-1.14.22-1.98-.54-1.98-1.53v-1.15l.01-2c0-.7-.18-1.15-.43-1.36a1 1 0 0 1 .54-1.75c2.97-.33 4.34-1.48 4.34-4.66q0-1.42-.91-2.4a1 1 0 0 1-.2-1.05c.17-.41.25-.96.1-1.61q-.75.2-1.86.95a1 1 0 0 1-.84.13 9.6 9.6 0 0 0-5.18 0 1 1 0 0 1-.83-.13q-1.12-.74-1.87-.95a2.7 2.7 0 0 0 .1 1.61 1 1 0 0 1-.2 1.05q-.9.97-.9 2.4c0 3.17 1.36 4.33 4.31 4.66a1 1 0 0 1 .55 1.75c-.2.17-.43.73-.43 1.36v3.15c0 .99-.84 1.73-1.96 1.53a1 1 0 0 1-.04-1.96v-1a3.5 3.5 0 0 1-2.26-.48" />
  </Icon>
);
